<template>
  <div>
    <StudentDetail
      v-if="contactUser && recordId"
      :contact="contactUser"
      :contactId="contactUser.contact_id"
      :id="recordId"
      :routine-student-id="recordId"
      :homeroomTeacher="homeroomTeacher"
      :homeroomTeacherName="homeroomTeacherName"
      :levels="levels"
      :taskType="taskType"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import StudentCareServices from '@/services/StudentCareServices';
import { SCHOOL_LEVEL } from '@/helpers/constant';
import { setPageTitle } from '@/helpers/utils';
import { LEVELS } from './store/mutation-types';
import StudentDetail from './components/StudentDetail.vue';

export default {
  components: {
    StudentDetail,
  },
  data() {
    return {
      contactUser: null,
      recordId: null,
      homeroomTeacher: {},
      levels: LEVELS,
      homeroomTeacherName: '',
    };
  },
  async created() {
    Bus.$on('reload-student-detail-info', (id) => {
      this.getDetailStudent(id);
    });
    this.recordId = Number(this.$route.params.id);
    this.taskType = Number(this.$route.query.taskType);
    this.getListGVCN();
    await this.getDetailStudent();
    await this.getListStatus({ type_curriculum: this.$route.query.typeCurriculum });
    const title = this.$route.query.tutorSchoolLevel === SCHOOL_LEVEL.PRIMARY ? 'GSTH' : 'GSTHCS';
    setPageTitle(`${title} - Chi tiết - ${this.contactUser.full_name}`);
  },
  methods: {
    ...mapActions('contact_status', ['getListStatus']),
    ...mapActions('student_care', ['getListGVCN']),
    async getDetailStudent(studentId = null) {
      const loading = this.$loading.show();
      const res = await StudentCareServices.fgGetListCareBlender({
        obj: 'routine',
        attrs: [
          'id', 'contact_id', 'lms_core_user_id', 'student_id', 'full_name', 'customer_id', 'call_id',
          'call_status_id', 'type_customer_care', 'type_curriculum', 'curriculum_id', 'subject_id',
          'subject_id_list', 'mobile', 'code', 'contact_code', 'homeroom_teacher_id', 'homeroom_teacher_name',
          'status_id', 'student_product_id',
        ],
        'filters[$eq__id]': studentId || this.$route.params.id,
      });
      if (res && res.data) {
        // eslint-disable-next-line prefer-destructuring
        this.contactUser = res.data[0];
        this.homeroomTeacher = { id: res.data[0].homeroom_teacher_id ? res.data[0].homeroom_teacher_id : null, name: res.data[0].homeroom_teacher_name ? res.data[0].homeroom_teacher_name : null };
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: 'Có lỗi xảy ra. Vui lòng thử lại!',
        });
      }
      loading.hide();
    },
  },
  destroyed() {
    Bus.$off('reload-student-detail-info');
  },
};
</script>

<style>
</style>
